module.exports = __webpack_public_path__ + "img/bat.0ef9b8b8.svg";